import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={s.root}>
      <div style={s.card}>
        <div style={s.code}>404</div>
        <h1 style={s.title}>Página não encontrada</h1>
        <p style={s.sub}>O endereço que você acessou não existe ou foi removido.</p>
        <Link to="/" style={s.btn}>← Voltar para a home</Link>
      </div>
    </div>
  );
}

const s = {
  root: {
    minHeight: '100vh',
    background: '#f3f4f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter, sans-serif',
    padding: '24px',
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    padding: '56px 48px',
    textAlign: 'center',
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
    maxWidth: 420,
    width: '100%',
  },
  code: {
    fontSize: 96,
    fontWeight: 800,
    color: '#e5e7eb',
    lineHeight: 1,
    marginBottom: 16,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#111827',
    margin: '0 0 12px',
  },
  sub: {
    fontSize: 15,
    color: '#6b7280',
    margin: '0 0 32px',
    lineHeight: 1.6,
  },
  btn: {
    display: 'inline-block',
    background: '#1e40af',
    color: '#fff',
    padding: '12px 28px',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    textDecoration: 'none',
  },
};
